import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import {
  getDayReports,
  getInventoryInOutReport,
  getItemReports,
  selectDayReports,
  selectInventoryInOutReports,
  selectItemReports,
  selectReportLoading,
} from "../../redux/features/report/ReportSlice";
import dayjs from "dayjs";
import logo from "../../Asset/logo.png";
// import jsPDF from "jspdf";
import { FaDownload } from "react-icons/fa";
import {
  filterDayReports,
  filterInventoryInOutReport,
  filterItemReports,
  selectFilteredDayReports,
  selectFilteredInventoryInOutReports,
  selectFilteredItemReports,
} from "../../redux/features/filter/FilterSlice";
import LoadingSpinner from "../../component/Loader/LoadingSpinner";

const Reports = () => {
  const dispatch = useDispatch();
  const [option, setOption] = useState("Day Report");
  const [searchDayReport, setSearchDayReport] = useState();
  const [searchItemReport, setSearchItemReport] = useState();
  const [searchInventoryInOutReport, setSearchInventoryInOutReport] =
    useState();
  const dayReports = useSelector(selectDayReports);
  const itemReports = useSelector(selectItemReports);
  const inventoryInOutReports = useSelector(selectInventoryInOutReports);
  const filteredDayReports = useSelector(selectFilteredDayReports);
  const filteredItemReports = useSelector(selectFilteredItemReports);
  const filteredInventoryInOutReports = useSelector(
    selectFilteredInventoryInOutReports
  );

  const loading = useSelector(selectReportLoading);
  const [selectedOption, setSelectedOption] = useState("allDetails");

  useEffect(() => {
    dispatch(getDayReports());
    dispatch(getItemReports());
    dispatch(getInventoryInOutReport());
  }, [dispatch]);

  const [selectedDayReport, setselectedDayReport] = useState(
    filteredDayReports[0]
  );
  const [selectedItemReport, setselectedItemReport] = useState(
    filteredItemReports[0]
  );
  const [
    selectedInventoryInOutReportReport,
    setselectedInventoryInOutReportReport,
  ] = useState(filteredInventoryInOutReports[0]);

  const freeOrders = selectedDayReport?.orders?.filter(
    (order) =>
      order.totalAmount + order.serviceCharges === order.totalAmountDiscount
  );

  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const dayReportPDF = useRef();
  const generateDayReportPDF = () => {
    const printContent = dayReportPDF.current;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const itemReportPDF = useRef();
  const generateItemReportPDF = () => {
    const printContent = itemReportPDF.current;

    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const formatPKR = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    })
      .format(amount)
      .replace("PKR", "Rs.");
  };

  useEffect(() => {
    dispatch(filterDayReports({ searchDayReport, dayReports }));
  }, [dispatch, searchDayReport, dayReports]);

  useEffect(() => {
    dispatch(filterItemReports({ searchItemReport, itemReports }));
  }, [dispatch, searchItemReport, itemReports]);

  useEffect(() => {
    dispatch(
      filterInventoryInOutReport({
        searchInventoryInOutReport,
        inventoryInOutReports,
      })
    );
  }, [dispatch, searchInventoryInOutReport, inventoryInOutReports]);

  return (
    <>
      {loading && <LoadingSpinner />}

      <div className="flex flex-col h-screen bg-[#F1F1F1]">
        <Navbar page={"Report"} />
        <div className="flex h-full overflow-hidden">
          <div className="lg:w-[30%] md:w-[39%] w-[35%] overflow-y-auto scrollbar-hide bg-white shadow-md">
            <div className="text-center sticky top-0 w-full bg-gray-400 md:py-2 py-1">
              <select
                value={option}
                onChange={(e) => setOption(e.target.value)}
                className="w-[90%] outline-none md:py-2 py-1 bg-transparent md:text-[1rem] text-[.8rem] "
              >
                <option
                  className="md:text-[.8rem] text-[.6rem]"
                  value="Day Report"
                >
                  Day Report
                </option>
                <option
                  className="md:text-[.8rem] text-[.6rem]"
                  value="Item Report"
                >
                  Item Report
                </option>
                <option
                  className="md:text-[.8rem] text-[.6rem]"
                  value="InventoryInOut Report"
                >
                  Inventory Report
                </option>
              </select>
            </div>
            {/* <reportList /> */}

            {option === "Day Report" ? (
              <div className="flex flex-col ">
                <div className="w-full ">
                  <input
                    type="date"
                    value={searchDayReport}
                    onChange={(e) => setSearchDayReport(e.target.value)}
                    className="outline-none md:p-4 p-2 w-full"
                    placeholder="Search by Date..."
                  />
                </div>
                {filteredDayReports?.map((dayReport, i) => (
                  <div
                    key={dayReport?._id}
                    onClick={() => setselectedDayReport(dayReport)}
                  >
                    <h1
                      className={`md:text-[14px] text-[10px] font-bold ${
                        selectedDayReport?._id === dayReport?._id
                          ? "bg-slate-600 text-white"
                          : ""
                      } hover:bg-slate-300 cursor-pointer md:py-3 py-1 md:px-2 px-1 border-b ${
                        i === 0 ? "border-t" : ""
                      } `}
                    >
                      {dayjs(dayReport.fromDateTime).format(
                        "D/MM/YY (ddd) h:mm A "
                      )}
                      -{" "}
                      {dayjs(dayReport.createdAt).format(
                        "D/MM/YY (ddd) h:mm A"
                      )}
                    </h1>
                  </div>
                ))}
              </div>
            ) : option === "Item Report" ? (
              <div className="flex flex-col ">
                <div className="w-full ">
                  <input
                    type="date"
                    value={searchItemReport}
                    onChange={(e) => setSearchItemReport(e.target.value)}
                    className="outline-none md:p-4 p-2 w-full"
                    placeholder="Search by Date..."
                  />
                </div>
                {filteredItemReports?.map((itemReport, i) => (
                  <div
                    key={itemReport?._id}
                    onClick={() => setselectedItemReport(itemReport)}
                  >
                    <h1
                      className={`md:text-[14px] text-[10px] font-bold ${
                        selectedItemReport?._id === itemReport?._id
                          ? "bg-slate-600 text-white"
                          : ""
                      } hover:bg-slate-300 cursor-pointer md:py-3 py-1 md:px-2 px-1 border-b ${
                        i === 0 ? "border-t" : ""
                      }`}
                    >
                      {dayjs(itemReport.fromDateTime).format(
                        "D/MM/YY (ddd) h:mm A "
                      )}
                      -{" "}
                      {dayjs(itemReport.createdAt).format(
                        "D/MM/YY (ddd) h:mm A"
                      )}
                    </h1>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col ">
                <div className="w-full ">
                  <input
                    type="date"
                    value={searchInventoryInOutReport}
                    onChange={(e) =>
                      setSearchInventoryInOutReport(e.target.value)
                    }
                    className="outline-none md:p-4 p-2 w-full"
                    placeholder="Search by Date..."
                  />
                </div>
                {filteredInventoryInOutReports?.map(
                  (inventoryInOutReport, i) => (
                    <div
                      key={inventoryInOutReport?._id}
                      onClick={() =>
                        setselectedInventoryInOutReportReport(
                          inventoryInOutReport
                        )
                      }
                    >
                      <h1
                        className={`md:text-[14px] text-[10px] font-bold ${
                          selectedInventoryInOutReportReport?._id ===
                          inventoryInOutReport?._id
                            ? "bg-slate-600 text-white"
                            : ""
                        } hover:bg-slate-300 cursor-pointer md:py-3 py-1 md:px-2 px-1 border-b ${
                          i === 0 ? "border-t" : ""
                        }`}
                      >
                        {dayjs(inventoryInOutReport?.fromDateTime).format(
                          "D/MM/YY (ddd) h:mm A "
                        )}
                        -{" "}
                        {dayjs(inventoryInOutReport?.createdAt).format(
                          "D/MM/YY (ddd) h:mm A"
                        )}
                      </h1>
                    </div>
                  )
                )}
              </div>
            )}
          </div>

          <div className="flex-1 lg:p-8 py-6 px-2 overflow-y-auto scrollbar-hide relative flex flex-col justify-between">
            <div className="lg:w-full w-[38rem]">
              {option === "Day Report" ? (
                selectedDayReport ? (
                  <div className="flex flex-col">
                    <div className="flex justify-end mb-2">
                      <button
                        onClick={generateDayReportPDF}
                        className="flex justify-center w-max items-center text-[white] bg-[#0D868C] rounded-lg p-2 font-semibold gap-2"
                      >
                        {" "}
                        <FaDownload />
                        DownLoad
                      </button>
                    </div>
                    <div
                      ref={dayReportPDF}
                      style={{ width: "100%" }}
                      className="bg-white w-[80%] mx-auto rounded-xl p-4 flex flex-col gap-2"
                    >
                      <div className="flex justify-between w-[95%] mx-auto">
                        {companyName && (
                          <p className="text-2xl text-[#575656] font-extrabold">
                            {companyName}
                          </p>
                        )}
                        <img src={logo} className="w-14 ml-auto" alt="" />
                      </div>
                      <div className="text-center text-[1.4rem] font-bold text-[#575656]">
                        Day Report
                      </div>
                      <div className="flex  justify-between items-center border-y py-2 border-gray-900 w-[95%] mx-auto">
                        <span>Opening Balance </span>
                        {formatPKR(selectedDayReport?.openingBalance)}
                      </div>
                      <div className="flex items-center w-[95%] mx-auto">
                        {[
                          "allDetails",
                          "orderDetails",
                          "expenseDetails",
                          "cashInDetails",
                        ].map((option) => (
                          <label
                            key={option}
                            className={`flex items-center cursor-pointer ${
                              selectedOption === option
                                ? "bg-blue-400"
                                : "bg-gray-400"
                            }  p-2 border`}
                          >
                            <input
                              type="radio"
                              name="detailType"
                              value={option}
                              checked={selectedOption === option}
                              onChange={(e) =>
                                setSelectedOption(e.target.value)
                              }
                              className="hidden"
                            />
                            <span className="capitalize">
                              {option.replace(/([A-Z])/g, " $1")}
                            </span>
                          </label>
                        ))}
                      </div>

                      {(selectedOption === "allDetails" ||
                        selectedOption === "orderDetails") && (
                        <>
                          <div className=" py-2 text-[.8rem] w-[95%] mx-auto">
                            <p className="text-center text-[1rem] font-semibold text-[#575656]">
                              Orders Details
                            </p>

                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex justify-between items-center">
                                <p>Total Orders Amount (Cash)</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders
                                      ?.filter(
                                        (order) => order.amountType === "cash"
                                      )
                                      .reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                            : order.totalAmount +
                                              order.serviceCharges),
                                        0
                                      )
                                  )}
                                </p>
                              </div>
                            )}

                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex justify-between items-center">
                                <p>Total Orders Amount (Card)</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders
                                      ?.filter(
                                        (order) => order.amountType === "card"
                                      )
                                      .reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                            : order.totalAmount +
                                              order.serviceCharges),
                                        0
                                      )
                                  )}
                                </p>
                              </div>
                            )}
                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex justify-between items-center">
                                <p>Total Orders Amount (Online)</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders
                                      ?.filter(
                                        (order) => order.amountType === "online"
                                      )
                                      .reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                            : order.totalAmount +
                                              order.serviceCharges),
                                        0
                                      )
                                  )}
                                </p>
                              </div>
                            )}
                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                <p>Total Orders Amount</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders?.reduce(
                                      (total, order) =>
                                        total +
                                        (order.totalAmountDiscount > 0
                                          ? order.totalAmountAfterDiscount +
                                            order.serviceCharges
                                          : order.totalAmount +
                                            order.serviceCharges),
                                      0
                                    )
                                  )}
                                </p>
                              </div>
                            )}

                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex  justify-between items-center">
                                <p>Total Service Charges</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders?.reduce(
                                      (total, order) =>
                                        total + Number(order.serviceCharges),
                                      0
                                    )
                                  )}
                                </p>
                              </div>
                            )}

                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex  justify-between items-center">
                                <p>Total Discount</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders?.reduce(
                                      (total, order) =>
                                        total +
                                        Number(order.totalAmountDiscount),
                                      0
                                    )
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="space-y-4 w-[95%] mx-auto">
                            <div className=" flex flex-col">
                              <div className="flex  items-center border  p-2 text-[.7rem] border-gray-900">
                                <div className="w-[5%]">Sr #</div>
                                <div className="w-[15%]">Order No</div>
                                <div className="w-[20%]">Order Amount</div>
                                <div className="w-[15%]">Discount</div>
                                <div className="w-[25%]">Discount Note</div>
                                <div className="w-[20%]">Charged Amount</div>
                              </div>
                              {selectedDayReport?.orders?.length > 0 &&
                                selectedDayReport?.orders?.map((order, i) => (
                                  <div className="flex  items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1">
                                    <div className="w-[5%] ">{i + 1}</div>
                                    <div className="w-[15%] ">
                                      #{order.orderNo}
                                    </div>
                                    <div className="w-[20%] ">
                                      {formatPKR(
                                        order.totalAmount + order.serviceCharges
                                      )}
                                    </div>
                                    <div className="w-[15%] ">
                                      {order.totalAmountDiscount > 0
                                        ? formatPKR(order.totalAmountDiscount)
                                        : "N/A"}
                                    </div>
                                    <div className="w-[25%] text-wrap capitalize ">
                                      {order.discountReason
                                        ? order.discountReason.toLowerCase()
                                        : "N/A"}
                                      {/* {order.discountReason.toLowerCase()} */}
                                    </div>
                                    <div className="w-[20%]">
                                      {formatPKR(
                                        order.totalAmountDiscount > 0
                                          ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                          : order.totalAmount +
                                              order.serviceCharges
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                            {selectedDayReport?.orders?.length > 0 && (
                              <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                <p>Total Orders Amount</p>
                                <p>
                                  {formatPKR(
                                    selectedDayReport?.orders?.reduce(
                                      (total, order) =>
                                        total +
                                        (order.totalAmountDiscount > 0
                                          ? order.totalAmountAfterDiscount +
                                            order.serviceCharges
                                          : order.totalAmount +
                                            order.serviceCharges),
                                      0
                                    )
                                  )}
                                </p>
                              </div>
                            )}
                            <p className="text-center text-[1rem] font-semibold text-[#575656] ">
                              100% Discount order
                            </p>

                            <div className=" flex flex-col">
                              <div className="flex  items-center border  p-2 text-[.7rem] border-gray-900">
                                <div className="w-[5%]">Sr #</div>
                                <div className="w-[15%]">Order No</div>
                                <div className="w-[20%]">Order Amount</div>
                                <div className="w-[15%]">Discount</div>
                                <div className="w-[25%]">Discount Note</div>
                                <div className="w-[20%]">Charged Amount</div>
                              </div>
                              {freeOrders.map((order, i) => (
                                <div key={i}>
                                  <div className="flex  items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1">
                                    <div className="w-[5%] ">{i + 1}</div>
                                    <div className="w-[15%] ">
                                      #{order.orderNo}
                                    </div>
                                    <div className="w-[20%] ">
                                      {formatPKR(
                                        order.totalAmount + order.serviceCharges
                                      )}
                                    </div>
                                    <div className="w-[15%] ">
                                      {formatPKR(order.totalAmountDiscount)}
                                    </div>
                                    <div className="w-[25%] text-wrap capitalize ">
                                      {order.discountReason.toLowerCase()}
                                    </div>
                                    <div className="w-[20%]">0.00</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {freeOrders?.length > 0 && (
                              <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                <p>Total 100% Discount order Amount</p>
                                <p>
                                  {formatPKR(
                                    freeOrders?.reduce(
                                      (total, order) =>
                                        total +
                                        (order.totalAmount +
                                          order.serviceCharges),
                                      0
                                    )
                                  )}
                                </p>
                              </div>
                            )}
                          </div>{" "}
                        </>
                      )}

                      {(selectedOption === "allDetails" ||
                        selectedOption === "expenseDetails") && (
                        <div className=" w-[95%] mx-auto">
                          <p className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                            Expense Out
                          </p>

                          <div className=" flex flex-col text-[.8rem] ">
                            <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900">
                              <div className="w-[5%]">Sr #</div>
                              <div className=" w-[75%]">Expense Note</div>
                              <div className="w-[20%]">Amount</div>
                            </div>
                            {selectedDayReport?.expenses?.map((expense, i) => (
                              <div className="flex  items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1 ">
                                <div className="w-[5%]">{i + 1}</div>
                                <div className=" capitalize w-[75%]">
                                  {expense?.description}
                                </div>
                                <div className="w-[20%]">
                                  {formatPKR(expense?.balance)}
                                </div>
                              </div>
                            ))}
                          </div>
                          {selectedDayReport?.expenses?.length > 0 && (
                            <div className="flex justify-between items-center mt-2 py-2 border-y border-gray-900 ">
                              <p>Total Expenses Amount</p>
                              <p>
                                {formatPKR(
                                  selectedDayReport?.expenses?.reduce(
                                    (total, expense) => total + expense.balance,
                                    0
                                  )
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                      {(selectedOption === "allDetails" ||
                        selectedOption === "cashInDetails") && (
                        <div className="w-[95%] mx-auto ">
                          <p className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                            Cash In
                          </p>

                          <div className=" flex flex-col ">
                            <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900">
                              <div className="w-[5%]">Sr #</div>
                              <div className=" w-[75%]">Cash In Note</div>
                              <div className="w-[20%]">Amount</div>
                            </div>
                            {selectedDayReport?.cashes?.map((cash, i) => (
                              <div className="flex  items-center  border border-t-0 border-gray-900 text-[.7rem] px-2 py-1 ">
                                <div className="w-[5%]">{i + 1}</div>
                                <div className="w-[75%] capitalize">
                                  {cash?.description}
                                </div>
                                <div className="w-[20%]">
                                  {formatPKR(cash?.balance)}
                                </div>
                              </div>
                            ))}
                          </div>
                          {selectedDayReport?.cashes?.length > 0 && (
                            <div className="flex justify-between items-center py-2 border-y border-gray-900 mt-2">
                              <p>Total Cash In Amount</p>
                              <p>
                                {formatPKR(
                                  selectedDayReport?.cashes?.reduce(
                                    (total, cash) => total + cash.balance,
                                    0
                                  )
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                      <div className="flex  justify-between items-center border-y my-2 w-[95%] mx-auto py-2 border-gray-900">
                        <span>Closing Balance</span>
                        {formatPKR(selectedDayReport?.closingBalance)}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>No Day Report</div>
                )
              ) : option === "Item Report" ? (
                selectedItemReport ? (
                  <div div className="flex flex-col">
                    <div className="flex justify-end mb-2">
                      <button
                        onClick={generateItemReportPDF}
                        className="flex justify-center w-max items-center text-[white] bg-[#0D868C] rounded-lg p-2 font-semibold gap-2"
                      >
                        {" "}
                        <FaDownload />
                        DownLoad
                      </button>
                    </div>
                    <div
                      ref={itemReportPDF}
                      style={{ width: "100%" }}
                      className="bg-white w-[80%] mx-auto rounded-xl p-4 flex flex-col gap-2"
                    >
                      <div className="flex justify-between w-[95%] mx-auto">
                        {companyName && (
                          <p className="text-2xl text-[#575656] font-extrabold">
                            {companyName}
                          </p>
                        )}
                        <img src={logo} className="w-14 ml-auto" alt="" />
                      </div>
                      <div className="text-center text-[1.4rem] font-bold text-[#575656]">
                        Item Report
                      </div>
                      <div className=" flex flex-col  w-[95%] mx-auto ">
                        <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900 ">
                          <div className="w-[5%]">Sr#</div>

                          <div className=" capitalize w-[40%]">Name</div>
                          <div className="w-[20%]">Price</div>
                          <div className="w-[15%]">Quantity</div>
                          <div className="w-[20%]">Total</div>
                        </div>
                        {selectedItemReport?.products?.map((product, i) => (
                          <div className="flex  items-center p-2 text-[.7rem] border border-gray-900">
                            <div className="w-[5%]">{i + 1}</div>

                            <div className=" capitalize w-[40%]">
                              {product?.name}
                            </div>
                            <div className="w-[20%]">
                              {formatPKR(product?.price)}
                            </div>
                            <div className="w-[15%]">{product?.quantity}</div>
                            <div className="w-[20%]">
                              {formatPKR(product?.price * product?.quantity)}
                            </div>
                          </div>
                        ))}
                      </div>
                      {selectedItemReport?.products?.length > 0 && (
                        <div className="flex justify-between w-[95%] mx-auto items-center py-2 border-y border-gray-900 mt-2">
                          <p>Total Sale Product Amount</p>
                          <p>
                            {formatPKR(
                              selectedItemReport?.products?.reduce(
                                (total, product) =>
                                  total + product?.price * product?.quantity,
                                0
                              )
                            )}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div>No Item Report</div>
                )
              ) : selectedInventoryInOutReportReport ? (
                <div div className="flex flex-col">
                  <div className="flex justify-end mb-2">
                    <button
                      onClick={generateItemReportPDF}
                      className="flex justify-center w-max items-center text-[white] bg-[#0D868C] rounded-lg p-2 font-semibold gap-2"
                    >
                      {" "}
                      <FaDownload />
                      DownLoad
                    </button>
                  </div>
                  <div
                    ref={itemReportPDF}
                    style={{ width: "100%" }}
                    className="bg-white w-[80%] mx-auto rounded-xl p-4 flex flex-col gap-2"
                  >
                    <div className="flex justify-between w-[95%] mx-auto">
                      {companyName && (
                        <p className="text-2xl text-[#575656] font-extrabold">
                          {companyName}
                        </p>
                      )}
                      <img src={logo} className="w-14 ml-auto" alt="" />
                    </div>
                    <div className="text-center text-[1.4rem] font-bold text-[#575656]">
                      Inventory Report
                    </div>
                    <div className=" flex flex-col  w-[95%] mx-auto ">
                      <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900 ">
                        <div className="w-[3%]">Sr#</div>

                        <div className=" capitalize w-[25%]">Name</div>
                        <div className="w-[12%]">Opening</div>
                        <div className="w-[12%]">In</div>
                        <div className="w-[12%]">Out</div>
                        <div
                          title="Inventory Adjustment In"
                          className="w-[12%]"
                        >
                          Adj In
                        </div>
                        <div
                          title="Inventory Adjustment Out"
                          className="w-[12%]"
                        >
                          Adj Out
                        </div>
                        <div className="w-[12%]">Closing</div>
                      </div>
                      {selectedInventoryInOutReportReport?.items.length > 0 && (
                        <div className="text-left border  p-2 text-[1rem] border-gray-900 ">
                          Item Details
                        </div>
                      )}
                      {selectedInventoryInOutReportReport?.items?.map(
                        (product, i) => (
                          <div className="flex  items-center p-2 text-[.7rem] border border-gray-900">
                            <div className="w-[3%]">{i + 1}</div>

                            <div className=" capitalize w-[25%]">
                              {product?.itemName}
                            </div>
                            <div
                              title={`${(
                                product?.itemQuantity -
                                product?.itemIn -
                                product?.inventoryAdjustIn *
                                  product.conversionRate +
                                (product?.itemOut +
                                  product?.inventoryAdjustOut *
                                    product.conversionRate)
                              ).toFixed(2)} ${product.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {product?.itemQuantity -
                                product?.itemIn -
                                product?.inventoryAdjustIn *
                                  product.conversionRate +
                                (product?.itemOut +
                                  product?.inventoryAdjustOut *
                                    product.conversionRate) <
                              product.conversionRate
                                ? `${(
                                    product?.itemQuantity -
                                    product?.itemIn -
                                    product?.inventoryAdjustIn *
                                      product.conversionRate +
                                    (product?.itemOut +
                                      product?.inventoryAdjustOut *
                                        product.conversionRate)
                                  ).toFixed(2)} ${product.inventoryUnit}`
                                : `${(
                                    (product?.itemQuantity -
                                      product?.itemIn -
                                      product?.inventoryAdjustIn *
                                        product.conversionRate +
                                      (product?.itemOut +
                                        product?.inventoryAdjustOut *
                                          product.conversionRate)) /
                                    product.conversionRate
                                  ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                            </div>
                            <div
                              title={`${product?.itemIn?.toFixed(2)} ${
                                product.inventoryUnit
                              }`}
                              className="w-[12%]"
                            >
                              {product?.itemIn < product.conversionRate
                                ? `${product?.itemIn?.toFixed(2)} ${
                                    product.inventoryUnit
                                  }`
                                : `${(
                                    product?.itemIn / product.conversionRate
                                  ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                            </div>
                            <div
                              title={`${product?.itemOut?.toFixed(2)} ${
                                product.inventoryUnit
                              }`}
                              className="w-[12%]"
                            >
                              {" "}
                              {product?.itemOut < product.conversionRate
                                ? `${product?.itemOut?.toFixed(2)} ${
                                    product.inventoryUnit
                                  }`
                                : `${(
                                    product?.itemOut / product.conversionRate
                                  ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                            </div>
                            <div
                              title={`${(
                                product?.inventoryAdjustIn *
                                product.conversionRate
                              ).toFixed(2)} ${product.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {" "}
                              {product?.inventoryAdjustIn?.toFixed(2)}
                              {product.purchaseUnit}
                            </div>
                            <div
                              title={`${(
                                product?.inventoryAdjustOut *
                                product.conversionRate
                              ).toFixed(2)} ${product.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {" "}
                              {product?.inventoryAdjustOut?.toFixed(2)}
                              {product.purchaseUnit}
                            </div>
                            <div
                              title={`${product?.itemQuantity?.toFixed(2)} ${
                                product.inventoryUnit
                              }`}
                              className="w-[12%]"
                            >
                              {product?.itemQuantity < product.conversionRate
                                ? `${product?.itemQuantity?.toFixed(2)} ${
                                    product.inventoryUnit
                                  }`
                                : `${(
                                    product?.itemQuantity /
                                    product.conversionRate
                                  ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                            </div>
                          </div>
                        )
                      )}
                      {selectedInventoryInOutReportReport?.ingredients.length >
                        0 && (
                        <div className="text-left border  p-2 text-[1rem] border-gray-900 ">
                          Ingredients Details
                        </div>
                      )}
                      {selectedInventoryInOutReportReport?.ingredients?.map(
                        (ingredient, i) => (
                          <div className="flex  items-center p-2 text-[.7rem] border border-gray-900">
                            <div className="w-[3%]">{i + 1}</div>

                            <div className=" capitalize w-[25%]">
                              {ingredient?.ingredientName}
                            </div>
                            <div
                              title={`${(
                                ingredient?.ingredientQuantity -
                                ingredient?.ingredientIn -
                                ingredient?.inventoryAdjustIn *
                                  ingredient.conversionRate +
                                (ingredient?.ingredientOut +
                                  ingredient?.inventoryAdjustOut *
                                    ingredient.conversionRate)
                              ).toFixed(2)} ${ingredient.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {ingredient?.ingredientQuantity -
                                ingredient?.ingredientIn -
                                ingredient?.inventoryAdjustIn *
                                  ingredient.conversionRate +
                                (ingredient?.ingredientOut +
                                  ingredient?.inventoryAdjustOut *
                                    ingredient.conversionRate) <
                              ingredient.conversionRate
                                ? `${(
                                    ingredient?.ingredientQuantity -
                                    ingredient?.ingredientIn -
                                    ingredient?.inventoryAdjustIn *
                                      ingredient.conversionRate +
                                    (ingredient?.ingredientOut +
                                      ingredient?.inventoryAdjustOut *
                                        ingredient.conversionRate)
                                  ).toFixed(2)} ${ingredient.inventoryUnit}`
                                : `${(
                                    (ingredient?.ingredientQuantity -
                                      ingredient?.ingredientIn -
                                      ingredient?.inventoryAdjustIn *
                                        ingredient.conversionRate +
                                      (ingredient?.ingredientOut +
                                        ingredient?.inventoryAdjustOut *
                                          ingredient.conversionRate)) /
                                    ingredient.conversionRate
                                  ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                            </div>
                            <div
                              title={`${ingredient?.ingredientIn?.toFixed(2)} ${
                                ingredient.inventoryUnit
                              }`}
                              className="w-[12%]"
                            >
                              {ingredient?.ingredientIn <
                              ingredient.conversionRate
                                ? `${ingredient?.ingredientIn?.toFixed(2)} ${
                                    ingredient.inventoryUnit
                                  }`
                                : `${(
                                    ingredient?.ingredientIn /
                                    ingredient.conversionRate
                                  ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                            </div>
                            <div
                              title={`${ingredient?.ingredientOut?.toFixed(
                                2
                              )} ${ingredient.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {" "}
                              {ingredient?.ingredientOut <
                              ingredient.conversionRate
                                ? `${ingredient?.ingredientOut?.toFixed(2)} ${
                                    ingredient.inventoryUnit
                                  }`
                                : `${(
                                    ingredient?.ingredientOut /
                                    ingredient.conversionRate
                                  ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                            </div>
                            <div
                              title={`${(
                                ingredient?.inventoryAdjustIn *
                                ingredient.conversionRate
                              ).toFixed(2)} ${ingredient.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {" "}
                              {ingredient?.inventoryAdjustIn.toFixed(2)}
                              {ingredient.purchaseUnit}
                            </div>
                            <div
                              title={`${(
                                ingredient?.inventoryAdjustIn *
                                ingredient.conversionRate
                              ).toFixed(2)} ${ingredient.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {" "}
                              {ingredient?.inventoryAdjustOut.toFixed(2)}
                              {ingredient.purchaseUnit}
                            </div>

                            <div
                              title={`${ingredient?.ingredientQuantity?.toFixed(
                                2
                              )} ${ingredient.inventoryUnit}`}
                              className="w-[12%]"
                            >
                              {ingredient?.ingredientQuantity <
                              ingredient.conversionRate
                                ? `${ingredient?.ingredientQuantity?.toFixed(
                                    2
                                  )} ${ingredient.inventoryUnit}`
                                : `${(
                                    ingredient?.ingredientQuantity /
                                    ingredient.conversionRate
                                  ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div>No Inventory In Out Report</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
